import { Stack } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { ErrorBoundary } from "../../../components/ErrorBoundary";
import { AircraftLastUpdated } from "./AircraftLastUpdated";
import { FlightBridgeStatus } from "./FlightBridgeStatus";
import { RenderJobHistory } from "./RenderJobHistory/RenderJobHistory";
import { WorkerStatus } from "./WorkerStatus";

export const UberAdmin: React.FC<{}> = () => {
  const { t } = useTranslation();

  return (
    <Stack direction="column" spacing={4} maxWidth={1000}>
      <WorkerStatus />
      <FlightBridgeStatus />
      <ErrorBoundary
        fallbackTitle={t("screens.superAdmin.uberAdmin.errorBoundary.title")}
        fallbackDescription={t("screens.superAdmin.uberAdmin.errorBoundary.description")}
      >
        <RenderJobHistory />
      </ErrorBoundary>
      <AircraftLastUpdated />
    </Stack>
  );
};
